import axios from 'axios';
import { BASE_URL } from '../../../model/base-url';

export const PRODUCTS_URL = `${BASE_URL}/api/products`;

// CREATE =>  POST: add a new product to the server
export function createProduct(product) {
  return axios({
    method: 'post',
    url: PRODUCTS_URL,
    data: product,
  });
}

// READ
export function getAllProducts() {
  return axios.get(PRODUCTS_URL);
}

export function getProductById(productId) {
  return axios.get(`${PRODUCTS_URL}/${productId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findProducts(queryParams) {
  const query = {
    Model: queryParams.filter.model,
    Brand: queryParams.filter.brand,
    Name: queryParams.filter.name,
    Status: queryParams.filter.status,
    sortOrder: queryParams.sortOrder,
    sortField: queryParams.sortField,
    pageNumber: queryParams.pageNumber,
    pagesize: queryParams.pageSize,
  };
  return axios({
    method: 'post',
    url: `${PRODUCTS_URL}/find`,
    data: query,
  });
}

// UPDATE => PUT: update the procuct on the server
export function updateProduct(product) {
  return axios.put(`${PRODUCTS_URL}/${product.id}`, { product });
}

// UPDATE Status
export function updateStatusForProducts(ids, status) {
  const query = {
    ids,
    status,
  };
  return axios({
    method: 'post',
    url: `${PRODUCTS_URL}/UpdateStatuses`,
    data: query,
  });
}

// DELETE => delete the product from the server
export function deleteProduct(productId) {
  return axios.delete(`${PRODUCTS_URL}/${productId}`);
}

// DELETE Products by ids
export function deleteProducts(ids) {
  return axios.post(`${PRODUCTS_URL}/deleteProducts`, { ids });
}
